import { z } from 'zod';

export const EventTypeSchema = z.enum([
  'NORMAL',
  'PAYDAY',
  'MID_MONTH',
  'MINI_SPIKE',
  'DOUBLE_DAY',
  'MEGA_SALE',
]);
export type EventType = z.infer<typeof EventTypeSchema>;

export const DayTypeSchema = z.enum(['WEEKDAY', 'WEEKEND', 'HOLIDAY']);
export type DayType = z.infer<typeof DayTypeSchema>;

export const DayCalendarEntrySchema = z.object({
  date: z.string(), // ISO date YYYY-MM-DD
  day_type: DayTypeSchema,
  event_type: EventTypeSchema,
  event_label: z.string().nullable().default(null), // "Mega Sale 11.11"
  is_active: z.boolean().default(true),
});
export type DayCalendarEntry = z.infer<typeof DayCalendarEntrySchema>;

/**
 * Cut-off days (engine derives from event_type).
 * Submission after this many days before target = is_late=true.
 */
export const CUTOFF_DAYS_BY_EVENT: Record<EventType, number> = {
  NORMAL: 1,
  PAYDAY: 3,
  MID_MONTH: 3,
  MINI_SPIKE: 3,
  DOUBLE_DAY: 7,
  MEGA_SALE: 7,
};
